import { useEffect, useState } from 'react';

type Cor = 'primary' | 'success' | 'accent';

const CORES: Record<Cor, string> = {
  primary: 'bg-primary-500',
  success: 'bg-success-500',
  accent: 'bg-accent-500',
};

interface ProgressBarProps {
  /** 0 a 100. */
  valor: number;
  cor?: Cor;
  altura?: string;
  className?: string;
}

// Barra que anima de 0 até o valor em 600 ms (ease-out) ao aparecer.
export default function ProgressBar({
  valor,
  cor = 'primary',
  altura = 'h-2',
  className = '',
}: ProgressBarProps) {
  const pct = Math.max(0, Math.min(100, valor));
  const [largura, setLargura] = useState(0);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mq.matches) {
      setLargura(pct);
      return;
    }
    setLargura(0);
    const t = window.setTimeout(() => setLargura(pct), 40);
    return () => window.clearTimeout(t);
  }, [pct]);

  return (
    <div
      className={`w-full overflow-hidden rounded-full bg-background-200 ${altura} ${className}`}
      role="progressbar"
      aria-valuenow={Math.round(pct)}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className={`h-full rounded-full ${CORES[cor]} transition-[width] duration-[600ms] ease-out`}
        style={{ width: `${largura}%` }}
      />
    </div>
  );
}